import React, { useEffect, useState } from 'react';
import { Modal, Button, Row, Form, Spinner } from 'react-bootstrap';

const RewardPointModal = ({ show, handleClose, handleSubmit, rewardPoint, response }) => {
    const [minAmount, setMinAmount] = useState(0.0);
    const [maxAmount, setMaxAmount] = useState(0.0);
    const [points, setPoint] = useState(0);

    useEffect(() => {
        if (show) {
            if (rewardPoint) {
                // If editing, set form fields with plan data
                setMinAmount(rewardPoint.minAmount || 0.0);
                setMaxAmount(rewardPoint.maxAmount || 0.0);
                setPoint(rewardPoint.points || 0);
            } else {
                // Reset form fields if adding
                setMinAmount(0.0);
                setMaxAmount(0.0);
                setPoint(0);
            }
        }
    }, [show, rewardPoint]);

    const onSubmit = (e) => {
        e.preventDefault();
        handleSubmit({ 
            minAmount,
            maxAmount,
            points, 
            id: rewardPoint?.id // Include ID if editing
        });
    };

    const handleCloseModal = () => {
        // Reset form fields when closing the modal
        setMinAmount(0.0);
        setMaxAmount(0.0);
        setPoint(0);
        handleClose();
    };

    return (
        <Modal className='modal_style admin_modal_style' show={show} onHide={handleCloseModal}>
            <Modal.Header closeButton>
                <Modal.Title>{rewardPoint ? 'Edit Point' : 'Add Point'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={onSubmit}>
                    <Form.Group controlId="minAmount">
                        <Form.Label>Min Amount</Form.Label>
                        <Form.Control
                            type="number"
                            placeholder="Enter Amount"
                            value={minAmount}
                            onChange={(e) => setMinAmount(e.target.value)}
                        />
                    </Form.Group>
                    <Form.Group controlId="maxAmount">
                        <Form.Label>Max Amount</Form.Label>
                        <Form.Control
                            type="number"
                            placeholder="Enter Amount"
                            value={maxAmount}
                            onChange={(e) => setMaxAmount(e.target.value)}
                        />
                    </Form.Group>
                    <Form.Group controlId="point">
                        <Form.Label>Point</Form.Label>
                        <Form.Control
                            type="number"
                            placeholder="Enter Point"
                            value={points}
                            onChange={(e) => setPoint(e.target.value)}
                        />
                    </Form.Group>
                    <Row className="justify-content-end modal_footer mt-3"> 
                    <Button variant="primary modal_btn w-auto" type="submit" disabled={response}>
                        {response ? (
                            <>
                                <Spinner animation="border" size="sm" />{' '}
                                {rewardPoint ? 'Saving...' : 'Adding...'}
                            </>
                        ) : (
                            rewardPoint ? 'Save Changes' : 'Add Point'
                        )}
                    </Button>
                    </Row>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default RewardPointModal;
